// spec 260509-system-monitor C-2：① 段健康摘要。
//
// 渲染 OK / WARN / CRIT 徽章 + 主因短句（如 ``CPU 91%`` / ``LLM 模型服务 down``）。
//
// **不做 hysteresis**（design.md §4.2）：① 段的 level 必须即时反馈，徽章不能
// 因防抖被延迟。② 段的瓶颈切换才需要 hysteresis（在 ``useDerivePrimaryBottleneck``
// hook 里实装）。
//
// 点击整段 → 启动 / 聚焦 dashboard 并滚到顶部（patch 1：通过
// ``navigateToDashboard`` helper，确保 dashboard 没开时也能开起来）。

import type { MouseEvent, ReactElement } from 'react';

import { useDeriveHealthSummary } from '../../state/derive';
import { useHideHealthErrors } from '../hideErrorsFlag';
import { navigateToDashboard } from '../navigateToDashboard';

export function HealthSummarySection(): ReactElement {
  const real = useDeriveHealthSummary();
  // 后端 HIDE_HEALTH_ERRORS=1 时强制 OK 视觉；否则按真实状态渲染。
  // dashboard 走独立 derive，不受此屏蔽影响。
  const hide = useHideHealthErrors();
  const summary = hide ? { level: 'ok' as const, reason: '系统正常' } : real;

  const onClick = (e: MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    navigateToDashboard('top');
  };

  return (
    <a
      className={`sysmon-section sysmon-health sysmon-health-${summary.level}`}
      data-section="health"
      data-level={summary.level}
      href="#top"
      onClick={onClick}
      aria-label={`整机健康度 ${summary.level}：${summary.reason}`}
    >
      <span className="sysmon-health-badge">{summary.level.toUpperCase()}</span>
      <span className="sysmon-health-reason">{summary.reason}</span>
    </a>
  );
}

export default HealthSummarySection;
